// gloss
type ProfileUserEntity = {
  author?: { uuid?: string | null } | null;
  authorForumUserUuid?: string | null;
  forumUserUuid?: string | null;
  authorForumUserID?: string | null;
  forumUserID?: string | null;
  author_id?: string | null;
  fanUserUuid?: string | null;
  uuid?: string | null;
  userId?: string | null;
  userID?: string | null;
};

export const getProfileUserId = (entity?: ProfileUserEntity | null): string => {
  if (!entity) return '';
  return (
    entity.author?.uuid ||
    entity.authorForumUserUuid ||
    entity.forumUserUuid ||
    entity.authorForumUserID ||
    entity.forumUserID ||
    entity.author_id ||
    entity.fanUserUuid ||
    entity.uuid ||
    entity.userId ||
    entity.userID ||
    ''
  );
};
